<template>
  <ul class="log-list">
    <li v-for="(log, index) in sortedLogs" :key="index" class="log-card mb-2 p-2">
      <div class="log-content">
        <span class="log-span">{{ formatType(log.type) }} </span>
        <span class="log-span">{{ formatDate(log.timestamp) }} </span>
        by <span class="log-span">{{ log.changedBy?.name }} </span>
      </div>
      <div v-if="log.comment" class="log-note">"{{ log.comment }}"</div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { Alarm, AlarmActivationType } from '@/server/MakeSenseApp-backend'
import { computed, defineProps } from 'vue'
import moment from 'moment'

function formatType(type: AlarmActivationType | undefined) {
  if (type === undefined) {
    return ''
  }

  if (type === AlarmActivationType.Activate) {
    return 'Alarm Activated'
  } else {
    return 'Alarm Deactivated'
  }
}

function formatDate(value: Date | undefined) {
  if (value === undefined) {
    return '-'
  }
  return moment(value).format('YYYY-MM-DD hh:mm')
}

var props = defineProps({
  alarm: {
    required: true,
    type: Alarm
  }
})

const sortedLogs = computed(() => {
  return (
    props.alarm?.logs
      ?.slice()
      .sort((a, b) => new Date(b.timestamp ?? 0).getTime() - new Date(a.timestamp ?? 0).getTime())
      .slice(0, 3) ?? []
  )
})
</script>

<style scoped>
.log-list {
  list-style-type: none;
  padding: 0;
}

.log-card {
  background-color: transparent;
  border-radius: 5px;
  border: 1px solid transparent;
}

.log-content {
  font-style: italic;
  color: gray;
}

.log-span {
  margin-right: 12px;
}

.log-note {
  font-style: italic;
  color: gray;
  margin-top: 5px;
}
</style>
